import React from 'react';
import { StyleSheet } from 'react-native';
import { DNABox, DNAIcon, DNAIconStyleProps } from '@alucio/lux-ui';
import { useAppSettings } from 'src/state/context/AppSettings';

const S = StyleSheet.create({
  iconContainer: {
    width: 32,
    height: 32,
  },
})

interface CommonIconProps extends DNAIconStyleProps {
  variant: 'folder-row-warning'
  | 'folder-row-update'
  | 'folder-row-pin'
  | 'folder-row-pin-fill'
  | 'document-row-bookmarked'
  | 'warning'
  | 'warning-circle'
  | 'check'
  | 'help-circle'
  | 'close-circle'
  | 'lock'
  | 'lock-key'
  | 'lock-open'
  | 'lock-simple-open'
  | 'caret-left'
  | 'caret-right'
  | 'caret-down'
  | 'caret-up'
}

const CommonIcon: React.FC<CommonIconProps> = ({ variant, ...props }) => {
  const { deviceMode } = useAppSettings();
  const iconSize = deviceMode === 'desktop' ? 20 : 24;

  switch (variant) {
    case 'folder-row-warning':
      return (
        <DNABox alignY="center" alignX="center" style={S.iconContainer}>
          <DNAIcon.Styled status="warning" name="warning-circle" {...props} />
        </DNABox>
      )
    case 'folder-row-update':
      return (
        <DNABox alignY="center" alignX="center" style={S.iconContainer}>
          <DNAIcon.Styled status="danger" name="clock-clockwise" {...props} />
        </DNABox>
      )
    case 'folder-row-pin':
      return (
        <DNABox alignY="center" alignX="center" style={S.iconContainer}>
          <DNAIcon.Styled name="star" status='subtle' {...props} />
        </DNABox>
      )
    case 'folder-row-pin-fill':
      return (
        <DNABox alignY="center" alignX="center" style={S.iconContainer}>
          <DNAIcon.Styled name="star-fill" status="primary" {...props} />
        </DNABox>
      )
    case 'document-row-bookmarked':
      return (
        <DNABox alignY="center" alignX="center" style={S.iconContainer}>
          <DNAIcon.Styled status="tertiary" name="bookmark-simple-fill" {...props} />
        </DNABox>
      )
    case 'warning':
      return <DNAIcon.Styled status="warning" name="warning" {...props} />
    case 'warning-circle':
      return <DNAIcon.Styled status="warning" name="warning-circle" {...props} />
    case 'check':
      return <DNAIcon.Styled status="success" name="check" {...props} />
    case 'help-circle':
      return <DNAIcon.Styled status="subtle" width={iconSize} height={iconSize} name="question" {...props} />
    case 'close-circle':
      return <DNAIcon.Styled status="tertiary" size="sm" name="x-circle-fill" {...props} />
    case 'lock-key':
      return <DNAIcon.Styled status="subtle" name="lock-key" {...props} />
    case 'lock':
      return <DNAIcon.Styled status="subtle" name="lock" {...props} />
    case 'lock-open':
      return <DNAIcon.Styled status="subtle" name="lock-open" {...props} />
    case 'lock-simple-open':
      return <DNAIcon.Styled status="subtle" name="lock-simple-open" {...props} />
    case 'caret-left':
      return <DNAIcon.Styled status="subtle" name="caret-left" {...props} />
    case 'caret-right':
      return <DNAIcon.Styled status="subtle" name="caret-right" {...props} />
    case 'caret-down':
      return <DNAIcon.Styled status="subtle" name="caret-down" {...props} />
    case 'caret-up':
      return <DNAIcon.Styled status="subtle" name="caret-up" {...props} />
    default:
      return null
  }
}

export default CommonIcon;
